import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Measure from "react-measure";
import { func, instanceOf, shape, number, string, bool, arrayOf } from "prop-types";

import * as i18nUtils from "util/i18n";
import { actions as notificationActions } from "reducers/notification";
import { actions as transactionsActions, selectors as transactionsSelectors } from "reducers/transactions";

import Notification from "pages/_components/Notification";
import I18n from "pages/_components/I18n";

import GridTable from "pages/_components/GridTable/GridTable";

import classNames from "classnames";
import TransactionItem from "pages/transactions/_components/TransactionItem";
import Scroll from "pages/_components/Scroll";
import Button from "pages/_components/Button";
import PageLoading from "pages/_components/PageLoading";
import { SALARY_PAYMENT_ID_FORM } from "constants.js";
import EmptyScreenAlert from "pages/_components/EmptyScreenAlert/EmptyScreenAlert";
import { getRouteByState } from "../constants";

class List extends Component {
    static propTypes = {
        defaultFilters: shape({
            dateFrom: instanceOf(Date),
            dateTo: instanceOf(Date),
            pageNumber: number,
            filter: string,
        }),
        dispatch: func.isRequired,
        pageNumber: number,
        onlyPendings: bool,
        pendingDispatch: bool,
        filters: shape({
            idFilter: string,
            dateFrom: instanceOf(Date),
            dateTo: instanceOf(Date),
            pageNumber: number,
            minAmount: number,
            maxAmount: number,
        }),
        showSearchButton: bool.isRequired,
        transactions: arrayOf(shape({})),
        isDesktop: bool.isRequired,
        hasMoreData: bool.isRequired,
        fetching: bool.isRequired,
        showEnvironment: bool,
        itemsAreClickeable: bool,
        noItemText: string,
        setTrxToCancel: func,
        handleOpenCancelForm: func,
        isPendingTransactionPage: bool,
    };

    static defaultProps = {
        defaultFilters: null,
        pageNumber: 1,
        onlyPendings: false,
        pendingDispatch: false,
        filters: null,
        showEnvironment: false,
        itemsAreClickeable: true,
        transactions: null,
        noItemText: "transactions.list.none",
        setTrxToCancel: null,
        handleOpenCancelForm: null,
        isPendingTransactionPage: false,
    };

    state = {
        searchMoreTransactionsVisible: false,
        dimensions: null,
    };

    fetchMoreTransactions = () => {
        const { defaultFilters, dispatch, pageNumber, onlyPendings, pendingDispatch } = this.props;
        let { filters } = this.props;

        filters = filters ? { ...filters, pageNumber } : { ...defaultFilters, pageNumber };

        dispatch(transactionsActions.loadMoreTransactionsRequest(filters, onlyPendings, pendingDispatch));
    };

    onPullForMoreInfo = () => {
        const { showSearchButton } = this.props;
        if (showSearchButton) {
            this.setState({ searchMoreTransactionsVisible: true });
        }
    };

    onMobileItemCLick = (event, transaction) => {
        const { dispatch, isDesktop } = this.props;

        if (
            transaction.transaction.idForm === SALARY_PAYMENT_ID_FORM &&
            !isDesktop &&
            transaction.transaction.idTransactionStatus === "DRAFT"
        ) {
            event.preventDefault();
            dispatch(
                notificationActions.showNotification(i18nUtils.get("massive.payments.mobile.disable"), "error", [
                    "transactionList",
                ]),
            );
        }
    };

    transactionRouteCondition = (idActivity, idTransaction, idTransactionStatus, routeParam) => {
        const routesByState = getRouteByState(idTransactionStatus, routeParam);
        const route = routesByState[idActivity];
        return route ? `${route}/${idTransaction}` : `/transaction/${idTransaction}`;
    };

    handleCancelTrx = (transaction) => {
        const { setTrxToCancel, handleOpenCancelForm } = this.props;
        if (setTrxToCancel) {
            setTrxToCancel(transaction);
        }
        if (handleOpenCancelForm) {
            handleOpenCancelForm();
        }
    }

    render() {
        const {
            transactions,
            hasMoreData,
            isDesktop,
            showSearchButton,
            fetching,
            showEnvironment,
            itemsAreClickeable,
            noItemText,
            isPendingTransactionPage,
        } = this.props;

        const { dimensions, searchMoreTransactionsVisible } = this.state;
        if (!transactions) {
            return null;
        }

        const list = transactions.map((transaction) => (
            <GridTable.Container
                key={transaction.transaction.idTransaction}
                renderAs={itemsAreClickeable ? Link : "div"}
                onClick={itemsAreClickeable ? (e) => this.onMobileItemCLick(e, transaction) : null}
                to={
                    itemsAreClickeable
                        ? this.transactionRouteCondition(
                              transaction.transaction.idActivity,
                              transaction.transaction.idTransaction,
                              transaction.transaction.idTransactionStatus,
                              transaction.transaction?.data?.routeParam,
                          )
                        : `/transactions/list`
                }>
                <TransactionItem
                    key={`transaction-${transaction.transaction.idTransaction}`}
                    transaction={transaction}
                    isDesktop={isDesktop}
                    showEnvironment={showEnvironment}
                    showAmount
                    handleOpenCancelForm={() => this.handleCancelTrx(transaction)}
                    isPendingTransactionPage={isPendingTransactionPage}
                />
            </GridTable.Container>
        ));

        if (!isDesktop) {
            if (!transactions.length) {
                return <EmptyScreenAlert message={noItemText} />;
            }
            const endOfListItem = (
                <div className="table-row table-end" key="noMoreTransactions">
                    <I18n id="transactions.list.noMoreTransactions" />
                </div>
            );
            return (
                <>
                    <Notification scopeToShow="transactionList" />
                    <Measure
                        bounds
                        onResize={(contentRect) => {
                            if (!dimensions) {
                                this.setState({ dimensions: contentRect.bounds });
                            }
                        }}>
                        {({ measureRef }) => (
                            <div
                                className={classNames("grid-table tablelist product-list pending-transactions", {
                                    environment: showEnvironment,
                                })}
                                ref={measureRef}>
                                {dimensions && (
                                    <Scroll
                                        containerBounds={dimensions}
                                        setTop={this.setTop}
                                        endOfListItem={endOfListItem}
                                        lastPage={!hasMoreData}
                                        isInfiniteScroll
                                        items={list}
                                        removeListenersWhenPulled
                                    />
                                )}
                            </div>
                        )}
                    </Measure>
                    {hasMoreData && (
                        <div className="text-center no-more-data">
                            <Button
                                bsStyle="link"
                                onClick={this.fetchMoreTransactions}
                                image="images/figma/icon/arrow.svg"
                                label="accounts.movements.moreMovements"
                            />
                        </div>
                    )}
                </>
            );
        }
        const endOfListItem = (
            <div className="table-row table-end" key="noMoreTransactions">
                <I18n id="transactions.list.noMoreTransactions" />
            </div>
        );
        return (
            <PageLoading loading={fetching}>
                <div
                    ref={(tableRef) => {
                        this.child = tableRef;
                    }}>
                    {transactions.length ? (
                        <GridTable
                            className={classNames("tablelist underlined pending-transactions", {
                                environment: showEnvironment,
                            })}>
                            {isDesktop && (
                                <GridTable.Header>
                                    <GridTable.Container>
                                        <GridTable.Data alignX="center" alignY="start">
                                            <I18n id="transactions.list.header.status" />
                                        </GridTable.Data>
                                        <GridTable.Data alignX="center" alignY="start">
                                            <I18n id="transactions.list.header.transactionName" />
                                        </GridTable.Data>
                                        {showEnvironment && (
                                            <GridTable.Data alignX="center" alignY="start">
                                                <I18n id="transactions.list.header.client" />
                                            </GridTable.Data>
                                        )}
                                        <GridTable.Data alignX="center" alignY="start">
                                            <I18n id="transactions.list.header.creationDate" />
                                        </GridTable.Data>
                                        <GridTable.Data alignX="center" alignY="start">
                                            <I18n id="transactions.list.header.submitDate" />
                                        </GridTable.Data>
                                        <GridTable.Data alignX="center" alignY="center">
                                            <I18n id="transactions.list.header.amount" />
                                        </GridTable.Data>
                                    </GridTable.Container>
                                </GridTable.Header>
                            )}
                            <GridTable.Body>
                                {isDesktop && list}
                                {isDesktop && showSearchButton && searchMoreTransactionsVisible && (
                                    <Link
                                        className="btn btn-block btn-link"
                                        key="searchMoreTransactionsButton"
                                        to="/transactions/list/filters">
                                        <I18n id="transactions.list.search" />
                                    </Link>
                                )}

                                {!isDesktop && dimensions && (
                                    <Scroll
                                        containerBounds={dimensions}
                                        setTop={this.setTop}
                                        endOfListItem={endOfListItem}
                                        fetchMoreData={this.fetchMoreTransactions}
                                        lastPage={!hasMoreData}
                                        isInfiniteScroll
                                        items={list}
                                        removeListenersWhenPulled
                                    />
                                )}
                            </GridTable.Body>
                        </GridTable>
                    ) : (
                        <EmptyScreenAlert message={noItemText} />
                    )}
                    {hasMoreData && (
                        <div className="text-center no-more-data">
                            <Button
                                bsStyle="link"
                                onClick={this.fetchMoreTransactions}
                                image="images/figma/icon/arrow.svg"
                                label="accounts.movements.moreMovements"
                            />
                        </div>
                    )}
                </div>
            </PageLoading>
        );
    }
}

const mapStateToProps = (state) => ({
    transactions: transactionsSelectors.getTransactions(state),
    hasMoreData: transactionsSelectors.getHasMoreData(state),
    fetching: transactionsSelectors.getFetching(state),
    pageNumber: transactionsSelectors.getPageNumber(state),
    filters: transactionsSelectors.getFilters(state),
});

export default connect(mapStateToProps)(List);
